import { render, staticRenderFns } from "./CommunityBox.vue?vue&type=template&id=7991c30e&scoped=true&"
import script from "./CommunityBox.vue?vue&type=script&lang=js&"
export * from "./CommunityBox.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBox.vue?vue&type=style&index=0&id=7991c30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7991c30e",
  null
  
)

export default component.exports